export default __webpack_public_path__ + "content/media/12.627e68c5.jpg";